import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { RiInformationFill } from 'react-icons/ri';
import { Currencies } from '../Components/Currencies';
import { Data } from '../PaymentMethods/Data';
import ReactLoading from 'react-loading';
import Payment from './Payment';
import OpenandCloseModal from './OpenandCloseModal';
import Modal from '../Components/Modal';
import { toast } from 'react-toastify';
import { formatAmount, getToken } from '../utils';

const initialiseInput = {
  amount: '',
  amount_currency: '',
  total_amount: '',
  total_amount_currency: '',
  account_id: '',
  transaction_method_id: '',
  account_type: '',
  receipient_type_id: '',
};

export const DirectTradeForm = ({ transactionType }) => {
  const [isGettingSystemRate, setIsGettingSystemRate] = useState(false);
  const [lvAccountDetails, setLvAccountDetails] = useState({});
  const [systemRate, setSystemRate] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [directTradeResponse, setDirectTradeResponse] = useState(false);
  const { handleOpenandCloseModal, openModal } = OpenandCloseModal();
  const [inputs, setInputs] = useState(initialiseInput);

  const { token: userToken } = getToken();

  const { currencys, accountTypes, transactionMethods } = Currencies();
  const { localData, foreignData } = Data();
  const allBankAccount = [...localData, ...foreignData];
  const { selectedNavlink } = transactionType;

  const defaultCurrencyId = currencys[0]?.id;
  inputs.amount_currency = inputs.amount_currency
    ? inputs.amount_currency
    : defaultCurrencyId;
  inputs.total_amount_currency = inputs.total_amount_currency
    ? inputs.total_amount_currency
    : defaultCurrencyId;

  const amountSymbol = currencys.find((data) => {
    return data.id === Number(inputs.amount_currency);
  });
  const TotalAmountSymbol = currencys.find((data) => {
    return data.id === Number(inputs.total_amount_currency);
  });

  const countryId = allBankAccount?.find((data) => {
    return data.id === Number(inputs.account_id);
  })?.country?.id;

  const handleChange = (e) => {
    const target = e.target;
    const { value, name } = target;
    setInputs((input) => ({
      ...input,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/direct-trade/store`,
        tradeDirectData,
        {
          headers: { Authorization: `Bearer ${userToken}` },
        }
      );
      setLvAccountDetails(response.data);
      setDirectTradeResponse(response.data);
      handleOpenandCloseModal('payment');
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const allInputs = [
    {
      id: 1,
      label: 'Bank account',
      name: 'account_id',
      value: inputs.account_id,
      option: allBankAccount,
      onchange: handleChange,
    },

    {
      id: 2,
      label: 'Recipient type',
      name: 'receipient_type_id',
      value: inputs.receipient_type_id,
      option: accountTypes,
      onchange: handleChange,
    },
    {
      id: 3,
      label: 'Transaction method',
      name: 'transaction_method_id',
      value: inputs.transaction_method_id,
      option: transactionMethods,
      onchange: handleChange,
    },
  ];

  const tradeDirectData = {
    transaction_type_id: selectedNavlink,
    base_currency_id: inputs.total_amount_currency,
    quote_currency_id: inputs.amount_currency,
    transaction_method_id: inputs.transaction_method_id,
    receipient_type_id: inputs.receipient_type_id,
    amount: inputs.amount,
    account_id: inputs.account_id,
    rate: systemRate?.price,
    deadline: 1696074540000,
    country_id: countryId,
  };

  //setting isgettingsystemrate to true
  useEffect(() => {
    if (
      inputs.amount &&
      inputs.amount_currency &&
      inputs.total_amount_currency !== ''
    ) {
      setIsGettingSystemRate(true);
    }
  }, [inputs.amount, inputs.amount_currency, inputs.total_amount_currency]);

  // fetch systemrate
  useEffect(() => {
    if (isGettingSystemRate) {
      const fetchSystemRate = async () => {
        const data = {
          base_currency_id: inputs.total_amount_currency,
          quote_currency_id: inputs.amount_currency,
        };
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BASE_URL}/exchange-rates/get-rate`,
            data,
            {
              headers: { Authorization: `Bearer ${userToken}` },
            }
          );
          setSystemRate(response.data);

          setIsGettingSystemRate(false);
        } catch (error) {
          console.log(error);

          setIsGettingSystemRate(false);
        }
      };
      fetchSystemRate();
    }
  }, [
    userToken,
    isGettingSystemRate,
    inputs.amount_currency,
    inputs.total_amount_currency,
  ]);

  const handleToast = (state, message) => {
    if (state === 'success') {
      toast.success(` ${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (state === 'error') {
      toast.error(`${message}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  return (
    <div>
      <form
        className='flex items-center flex-col gap-10 box-border font-normal'
        onSubmit={handleSubmit}
      >
        <div className='flex flex-col md:flex-row w-full gap-6'>
          <div className=' w-full flex flex-col gap-2'>
            <label className='text-s-bk text-base font-pin relative'>
              Amount
            </label>
            <div className='flex justify-between items-center w-full relative rounded-lg border-t-bk border-[1px]'>
              <input
                type='number'
                className='focus:outline-none focus:ring focus:b-mc w-full px-2 h-11 rounded-lg relative'
                name='amount'
                value={inputs.amount}
                onChange={handleChange}
                placeholder='0.00'
                required
              />
              <select
                name='amount_currency'
                className='py-2 absolut focus:outline-none focus:ring focus:b-mc w-2.5/6 h-11 pr-4 rounded-lg absolute right-0'
                value={inputs.amount_currency}
                onChange={handleChange}
                required
              >
                {currencys.map((currency) => (
                  <option
                    key={currency.id}
                    className='flex flex-row justify-center items-center'
                    value={currency.id}
                  >
                    {` ${currency.name} (${currency.symbol})`}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className=' w-full flex  flex-col gap-2'>
            <label className='text-s-bk text-base font-pin relative'>
              Total Amount{' '}
            </label>
            <div className='flex items-center w-full relative rounded-lg border-t-bk border-[1px]'>
              <p className='focus:outline-none flex items-center focus:ring focus:b-mc w-full px-2 h-11 rounded-lg relative'>
                {inputs.amount !== '' && systemRate?.price
                  ? formatAmount(inputs.amount * systemRate?.price)
                  : '0.00'}
              </p>

              <select
                name='total_amount_currency'
                className='py-2 absolut focus:outline-none focus:ring focus:b-mc w-2.5/6 h-11 pr-4 rounded-lg absolute right-0'
                value={inputs.total_amount_currency}
                onChange={handleChange}
                required
              >
                {currencys.map((currency) => (
                  <option
                    key={currency.id}
                    className='flex flex-row justify-center items-center'
                    value={currency.id}
                  >
                    {` ${currency.name} (${currency.symbol})`}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className='flex flex-col md:flex-row w-full gap-6'>
          <div className='flex flex-col gap-1 w-full md:w-1/2 border-y-hf py-2'>
            <div className='flex flex-row justify-between gap-2'>
              <p className='text-s-bk'>
                {selectedNavlink === 1 ? 'You are buying' : 'You are selling'}
              </p>
              <p>
                {inputs.amount
                  ? (inputs.amount * 1)?.toLocaleString() +
                    ' ' +
                    amountSymbol?.symbol
                  : '0.00'}{' '}
              </p>
            </div>
            <div className='flex flex-row justify-between gap-2'>
              <p className='text-s-bk'>Rate</p>
              <p>
                {systemRate?.price
                  ? formatAmount(systemRate?.price) +
                    ' ' +
                    TotalAmountSymbol?.symbol
                  : '0.00'}
              </p>
            </div>
            {/* <div className='flex flex-row justify-between gap-2'>
              <p className='text-s-bk'>Transation fee (0.01%)</p>
              <p>0.00</p>
            </div> */}
            <div className='flex flex-row justify-between gap-2'>
              <p className='text-s-bk'>You will receive</p>
              <p>
                {selectedNavlink === 1 ? inputs.amount !== '' && systemRate?.price
                  ? formatAmount(inputs.amount) +
                    ' ' +
                    amountSymbol?.symbol
                  : '0.00'
                : selectedNavlink === 2 ? inputs.amount !== '' && systemRate?.price
                ? formatAmount(inputs.amount * systemRate?.price) +
                  ' ' +
                  TotalAmountSymbol?.symbol
                : '0.00' : '0.00'}
              </p>
            </div>
            <div className='flex flex-row justify-between gap-2'>
              <p className='text-s-bk'>To be received within </p>
              <p>24h</p>
            </div>
          </div>
          <div className='flex flex-row gap-2 w-full md:w-1/2 text-s-bk bg-b-mct px-4 py-4 rounded'>
            <span className='text-2xl text-b-mc'>
              <RiInformationFill />
            </span>
            <p className='text-sm'>
              You will be charged 0.1% transaction fee if you are on a FREE plan
              or 0.05% for premium plan. To subscribe to any of the plan
              <span className='text-b-mc'>Click here</span>
            </p>
          </div>
        </div>

        <div className='grid grid-cols-2 w-full gap-6 items-end'>
          {allInputs?.map((data, index) => (
            <div className=' w-full flex flex-col gap-2' key={index}>
              <label className='text-s-bk text-base font-pin relative'>
                {data.label}
              </label>
              <div className='w-full rounded-lg border-t-bk border-[1px]'>
                <select
                  name={data.name}
                  className='py-2 absolut focus:outline-none focus:ring focus:b-mc w-full h-11 px-4 rounded-lg'
                  value={data.value}
                  onChange={data.onchange}
                  required
                >
                  <option value=''>Select ....</option>
                  {data?.option?.map((optiondata, index) => (
                    <option key={index} value={optiondata.id}>
                      {data.label === 'Bank account'
                        ? optiondata?.bank_name +
                          ',' +
                          ' ' +
                          optiondata?.currency?.name +
                          ',' +
                          ' ' +
                          optiondata?.currency?.symbol +
                          ',' +
                          ' ' +
                          optiondata?.country?.name
                        : optiondata?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}

          <button
            className={`rounded relative text-p-wh py-3 w-full h-fit font-semibold disabled:bg-b-mct ${
              selectedNavlink === 1
                ? 'bg-green-500 hover:bg-green-400 focus:bg-green-600'
                : 'bg-red-500 hover:bg-red-400 focus:bg-red-600'
            } `}
            disabled={isSubmitting}
          >
            {selectedNavlink === 1
              ? 'Buy CX'
              : selectedNavlink === 2
              ? 'Sell CX'
              : ''}
            {isSubmitting && (
              <ReactLoading
                type='cylon'
                color='#5AC8FA'
                height={44}
                width={44}
                className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
              />
            )}
          </button>
        </div>
      </form>
      <Modal open={openModal === 'payment'}>
        <Payment
          lvAccountDetails={lvAccountDetails}
          handleOpenandCloseModal={handleOpenandCloseModal}
          handleToast={handleToast}
        />
      </Modal>
      {/* <button onClick={() => handleOpenandCloseModal("payment")}>
        {" "}
        clickme
      </button> */}
    </div>
  );
};
